
import { ApiClient } from "../api/ApiClient";
import { CreateRawMaterialRequest, RawMaterialModel } from "../model/RawMaterialModel";

const BASE_ULR = "/api/raw-material";

class RawMaterialServiceClass {

  getListRawMaterial() {
    return ApiClient.get<RawMaterialModel[]>(BASE_ULR + "/list");
  }

  createRawMaterial(request: CreateRawMaterialRequest) {
    return ApiClient.post<RawMaterialModel>(BASE_ULR + `/save`, request);
  }

  updateRawMaterial(id: number, request: CreateRawMaterialRequest) {
    return ApiClient.put<RawMaterialModel>(BASE_ULR + `/update/${id}`, request);
  }

  deleteRawMaterial(id: number) {
    return ApiClient.delete(BASE_ULR + `/delete/${id}`);
  }
}

const RawMaterialService = new RawMaterialServiceClass();
export default RawMaterialService;